import { CheckBox, Label } from '@iwoca/orion';
import { Trans } from '@lingui/react/macro';
import { clsx } from 'clsx';
import { useFormContext } from 'react-hook-form';

import styles from './MarketingOptIn.module.css';
import { useLocale } from '../../../hooks/useLocale';
import { TGetStartedDataDE } from '../GetStartedDE/GetStartedDE';
import { TGetStartedDataUK } from '../GetStartedUK/GetStartedUK';

const MarketingOptIn = () => {
  const { register } = useFormContext<TGetStartedDataUK | TGetStartedDataDE>();
  const { isDE } = useLocale();

  return (
    <div className={styles.checkboxContainer}>
      <CheckBox {...register('marketingOptIn')} id="marketingOptInId" />
      <Label
        className={clsx(styles.checkBoxlabel, {
          [styles.checkBoxLabelDE]: isDE,
        })}
        htmlFor="marketingOptInId"
      >
        <Trans>
          Sign up for offers and stories from other small businesses.
        </Trans>
      </Label>
    </div>
  );
};

export default MarketingOptIn;
